module.exports = __webpack_public_path__ + "static/media/WATER-BUSD-LP.28fca010.png";